import { queryStringBuilder } from './queryStringBuilder';

export const exportXLSX = (request, query): Promise<string> => {
  const queryString = queryStringBuilder({
    page: 1,
    pageSize: 10000,
    filters: query?.filters,
    orderBy: query.orderBy || null,
    direction: query.orderDirection || null,
    search: query.searchString,
  });

  return new Promise((resolve, reject) => {
    if (!query) {
      reject(new Error('Query is required'));
      return;
    }

    request({ query: queryString })
      .then((result: Blob) => {
        const date = new Date();
        const url = window.URL.createObjectURL(result);
        const a = document.createElement('a');
        a.href = url;
        a.download = `listado_solicitudes_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();

        resolve(url);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
        return {
          data: [],
          totalCount: 0,
        };
      });
  });
};
